import React, {useState} from 'react';
import useGet from "../../../components/hooks/useGet";
import {backendEndpoints} from "../../../libs/backendEndpoints";
import {DataRow} from "../../../components/layout";
import {concepts, Group, Subscription} from "fearless-common";
import SeatsSpan from "../../../components/subscriptions/SeatsSpan";
import DotsMenu from "../../../components/layout/DotsMenu";
import ManageGroupSubscriptionModal from "../../../components/subscriptions/ManageGroupSubscriptionModal";
import {Alert, Loading, useTitle} from "fearless-common-ui";
type GroupWithSubscriptions = Group & { subscriptions: Subscription[] };

export default function GroupSubscriptionsOverview() {
    const { data: groups, isLoading, error } = useGet<Array<GroupWithSubscriptions>>({
        endpoint: backendEndpoints.getGroups,
        params: { _with: ['subscriptions'] }
    });
    const [activeGroup, setActiveGroup] = useState<GroupWithSubscriptions | null>(null);
    useTitle('My team subscriptions');

    if (isLoading) return <Loading />;
    if (error) return <Alert>{error}</Alert>;

    return (
        <>
            <DataRow label={<span className="ps-3">Number of {concepts.Groups.toLowerCase()}</span>}>{groups?.length}</DataRow>
            <table className="table mt-4">
                <tbody>
                {Array.isArray(groups) && groups.map((group) => (
                    <React.Fragment key={group.id}>
                        {Array.isArray(group.subscriptions) && group.subscriptions.length ? group.subscriptions?.map((subscription) => {
                            return (
                                <tr key={subscription.id}>
                                    <td className="ps-3">{group.name}</td>
                                    <td>
                                        Total seats:&nbsp;
                                        <SeatsSpan.Total totalSeats={group.total_seats} />
                                    </td>
                                    <td>
                                        Used seats:&nbsp;
                                        <SeatsSpan.Remaining
                                          totalSeats={group.total_seats}
                                          usedSeats={group.used_seats}
                                        />
                                    </td>
                                    <td>
                                        <DotsMenu
                                            options={[
                                                {
                                                    label: `${group.role === 'MANAGER' ? 'Edit' : 'View'} ${concepts.Subscription.toLowerCase()}`,
                                                    onClick: () => setActiveGroup(group),
                                                }
                                            ]}
                                        />
                                    </td>
                                </tr>
                            );
                        }) : (
                            <tr>
                                <td className="ps-3">{group.name}</td>
                                <td colSpan={2}>
                                    <a href="#" onClick={() => setActiveGroup(group)}>
                                        Get a {concepts.Subscription.toLowerCase()}
                                    </a>
                                </td>
                                <td>
                                    <DotsMenu
                                        options={[{
                                            label: `Get a ${concepts.Subscription.toLowerCase()}`,
                                            onClick: () => setActiveGroup(group),
                                        }]}
                                    />
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
            {activeGroup && <ManageGroupSubscriptionModal group={activeGroup} onClose={() => setActiveGroup(null)}/>}
        </>
    );
}
